import { BaseToast } from "./BaseToast";
import { ToastProps } from "./types";

export const WarningToast = ({ children, ...rest }: ToastProps) => {
  return (
    <BaseToast {...rest} toastType="warning">
      {children}
    </BaseToast>
  );
};
